import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TimePickerComponent } from '../../../../../components/time-picker/time-picker.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
    selector: 'publishing',
    templateUrl: './publishing.component.html',
    styleUrls: ['./publishing.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
    ],
    standalone: false
})
export class PublishingComponent implements OnInit {

  @Input() dynamicContent;
  weekdays;
  weekdayArray = [1, 2, 3, 4, 5, 6, 0];

  constructor(private dialog: MatDialog) {
    this.weekdays = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false };
  }

  ngOnInit() {
    this.dynamicContent.daily = this.dynamicContent.daily === undefined ? false : this.dynamicContent.daily;
    for (const element of this.dynamicContent.weekdaysInterval) {
      this.weekdays[element] = true;
    }
  }

  public resetPublishing() {
    this.dynamicContent.publishStart = null;
    this.dynamicContent.publishStartTime = null;
    this.dynamicContent.publishEnd = null;
    this.dynamicContent.publishEndTime = null;
    this.dynamicContent.daily = false;
    this.dynamicContent.dailyIntervalPublish = { start: null, end: null };
    this.dynamicContent.monthlyIntervalPublish = null;
    this.dynamicContent.weekdaysInterval = [0, 1, 2, 3, 4, 5, 6];
    this.weekdays = { 0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true };
  }

  public updateDynamicContentDays(event: any, i) {
    this.weekdays[i] = !this.weekdays[i]
    this.dynamicContent.weekdaysInterval = Object.keys(this.weekdays).filter(key => this.weekdays[key]).map(Number);
  }

  openTimePicker(time: string, type: string) {
    let dialogRef: MatDialogRef<TimePickerComponent>;

    if (time === undefined) {
      time = null;
    }

    dialogRef = this.dialog.open(TimePickerComponent, {
      width: '398px',
      height: '548px',
      panelClass: 'time',
      data: time
    });
    dialogRef.afterClosed().toPromise().then((result: any) => {
      if (!result) {
        return;
      }
      let hour = result.hour;
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (hour === 24) {
        hour = '00';
      }
      let minute = result.minute;
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (type.startsWith('start')) {
        this.dynamicContent.publishStartTime = hour + ':' + minute;
      } else {
        this.dynamicContent.publishEndTime = hour + ':' + minute;
      }
    });
  }
}
